import React, { FC } from 'react'
import { ModalProps } from './Modal.types'

// Plugins
import { Backdrop, Grow, Modal as MuiModal, makeStyles } from '@material-ui/core'

export const Modal: FC<ModalProps> = props => {
  const { open, onClose, children } = props
  const classes = useStyles(props)

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition={true}
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 1000 }}
    >
      <Grow in={open} timeout={800}>
        <div className={classes.paper} data-testid={'Modal'}>
          {children}
        </div>
      </Grow>
    </MuiModal>
  )
}

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: (props: ModalProps) => (props.fullscreen ? '100%' : '80vw'),
    height: 'auto',
    display: 'flex',

    outline: '0',
    '& *': { outline: '0' }
  }
}))
